<template>
  <span> {{ dateHumanDisplay }} </span>
</template>

<script lang="ts">
const DAY = 60 * 60 * 24
const MONTH = DAY * 30
const YEAR = MONTH * 12

export default defineNuxtComponent({
  props: {
    date: { type: Date, required: true },
  },
  setup(props) {
    const dateHumanDisplay = computed(() => {
      const now = Date.now()
      const diffInSeconds = Math.round((now - props.date.getTime()) / 1000)

      if (diffInSeconds >= YEAR) {
        const count = Math.floor(diffInSeconds / YEAR)

        if (count > 1) {
          return `hace ${count} años`
        }
        return `hace 1 año`
      }

      if (diffInSeconds >= MONTH) {
        const count = Math.floor(diffInSeconds / MONTH)

        if (count > 1) {
          return `hace ${count} meses`
        }
        return `hace 1 meses`
      }

      if (diffInSeconds >= DAY) {
        const count = Math.floor(diffInSeconds / DAY)

        if (count > 1) {
          return `hace ${count} días`
        }
        return `hace 1 dia`
      }

      return 'Hoy'
    })

    return {
      dateHumanDisplay
    }
  }
})
</script>
